import { useTranslation } from 'react-i18next';
import Header from '../../home/components/Header';
import Footer from '../../home/components/Footer';
import WhatsAppFloat from '../../home/components/WhatsAppFloat';
import SEO from '@/components/SEO';

export default function TransportPage() {
  const { t } = useTranslation('navigation');
  const isEn = t('home') === 'Home';

  const solutions = [
    {
      titleFr: 'Gestion de Flotte', titleEn: 'Fleet Management',
      descFr: 'Suivi en temps réel de votre flotte de véhicules', descEn: 'Real-time tracking of your vehicle fleet',
      icone: 'ri-truck-line',
      featuresFr: ['Géolocalisation temps réel des véhicules', 'Suivi de la consommation carburant', 'Maintenance préventive automatisée', 'Gestion des conducteurs', 'Alertes de sécurité et infractions'],
      featuresEn: ['Real-time vehicle geolocation', 'Fuel consumption tracking', 'Automated preventive maintenance', 'Driver management', 'Security alerts and violations'],
    },
    {
      titleFr: 'Optimisation des Routes', titleEn: 'Route Optimization',
      descFr: 'Planification intelligente des itinéraires de livraison', descEn: 'Smart delivery route planning',
      icone: 'ri-route-line',
      featuresFr: ["Calcul d'itinéraires optimaux", 'Prise en compte du trafic temps réel', 'Optimisation multi-critères', 'Planification des tournées', 'Réduction des coûts de transport'],
      featuresEn: ['Optimal route calculation', 'Real-time traffic consideration', 'Multi-criteria optimization', 'Tour planning', 'Transport cost reduction'],
    },
    {
      titleFr: 'Gestion des Livraisons', titleEn: 'Delivery Management',
      descFr: 'Suivi complet du processus de livraison', descEn: 'Complete delivery process tracking',
      icone: 'ri-archive-line',
      featuresFr: ['Suivi des colis en temps réel', 'Notifications clients automatiques', 'Preuve de livraison électronique', 'Gestion des retours', 'Historique complet des livraisons'],
      featuresEn: ['Real-time parcel tracking', 'Automatic client notifications', 'Electronic proof of delivery', 'Returns management', 'Complete delivery history'],
    },
    {
      titleFr: 'Gestion des Entrepôts', titleEn: 'Warehouse Management',
      descFr: "Optimisation de la logistique d'entrepôt", descEn: 'Warehouse logistics optimization',
      icone: 'ri-building-2-line',
      featuresFr: ['Gestion des emplacements', 'Optimisation des stocks', 'Préparation de commandes', 'Traçabilité des produits', 'Inventaires automatisés'],
      featuresEn: ['Location management', 'Stock optimization', 'Order preparation', 'Product traceability', 'Automated inventories'],
    },
    {
      titleFr: 'Facturation Transport', titleEn: 'Transport Billing',
      descFr: 'Gestion financière spécialisée transport', descEn: 'Specialized transport financial management',
      icone: 'ri-calculator-line',
      featuresFr: ['Calcul automatique des tarifs', 'Facturation clients automatisée', 'Gestion des frais de transport', 'Suivi des paiements', 'Rapports de rentabilité'],
      featuresEn: ['Automatic rate calculation', 'Automated client invoicing', 'Transport fee management', 'Payment tracking', 'Profitability reports'],
    },
    {
      titleFr: 'Tableaux de Bord', titleEn: 'Dashboards',
      descFr: 'Indicateurs de performance logistique', descEn: 'Logistics performance indicators',
      icone: 'ri-dashboard-line',
      featuresFr: ['KPI transport en temps réel', 'Analyse des performances', 'Suivi des coûts opérationnels', 'Rapports de productivité', 'Prévisions de demande'],
      featuresEn: ['Real-time transport KPIs', 'Performance analysis', 'Operational cost tracking', 'Productivity reports', 'Demand forecasts'],
    },
  ];

  const advantages = [
    { icon: 'ri-money-dollar-circle-line', titleKey: 'transportAdv1Title', descKey: 'transportAdv1Desc' },
    { icon: 'ri-speed-up-line', titleKey: 'transportAdv2Title', descKey: 'transportAdv2Desc' },
    { icon: 'ri-customer-service-line', titleKey: 'transportAdv3Title', descKey: 'transportAdv3Desc' },
    { icon: 'ri-shield-check-line', titleKey: 'transportAdv4Title', descKey: 'transportAdv4Desc' },
  ];

  return (
    <div className="min-h-screen bg-gray-50">
      <SEO
        title="Logiciel Transport & Logistique - Alpha Solutions | Gestion de Flotte"
        description="Solution complète pour transport et logistique : gestion de flotte, optimisation des routes, suivi des livraisons, entrepôts, facturation et tableaux de bord."
        keywords="logiciel transport Cameroun, gestion flotte Douala, logistique Afrique, tracking véhicules, TMS"
        canonicalPath="/secteurs/transport"
        schema={{
          "@context": "https://schema.org",
          "@type": "Service",
          "name": "Logiciel Transport & Logistique Alpha Solutions",
          "description": "Solution de gestion de flotte et logistique au Cameroun",
          "brand": { "@type": "Organization", "name": "Alpha Solutions" }
        }}
      />
      <Header />
      
      <section className="relative bg-cover bg-center py-20"
        style={{ backgroundImage: `linear-gradient(rgba(0,0,0,0.6),rgba(0,0,0,0.6)), url('https://readdy.ai/api/search-image?query=modern%20african%20logistics%20and%20transportation%20hub%20with%20advanced%20fleet%20management%20system%2C%20professional%20freight%20distribution%20center%20with%20digital%20vehicle%20tracking%20and%20route%20optimization%20technology&width=1200&height=600&seq=transport-hero&orientation=landscape')` }}>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center text-white">
            <h1 className="text-4xl md:text-6xl font-bold mb-6">{t('transportHeroTitle')}</h1>
            <p className="text-xl md:text-2xl mb-8 max-w-3xl mx-auto">{t('transportHeroDesc')}</p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <a href="https://wa.me/237693385267" target="_blank" rel="noopener noreferrer"
                className="bg-green-600 hover:bg-green-700 text-white px-8 py-4 rounded-lg font-semibold transition-colors cursor-pointer whitespace-nowrap">
                <i className="ri-whatsapp-line mr-2"></i>{t('sectorDemoBtn')}
              </a>
            </div>
          </div>
        </div>
      </section>

      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">{t('transportSolutionsTitle')}</h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">{t('transportSolutionsSubtitle')}</p>
          </div>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {solutions.map((sol, index) => (
              <div key={index} className="bg-white rounded-lg shadow-lg p-6 hover:shadow-xl transition-shadow">
                <div className="w-16 h-16 bg-blue-600 text-white rounded-full flex items-center justify-center mb-4">
                  <i className={`${sol.icone} text-2xl`}></i>
                </div>
                <h3 className="text-xl font-semibold text-gray-900 mb-3">{isEn ? sol.titleEn : sol.titleFr}</h3>
                <p className="text-gray-600 mb-4">{isEn ? sol.descEn : sol.descFr}</p>
                <ul className="space-y-2">
                  {(isEn ? sol.featuresEn : sol.featuresFr).map((f, idx) => (
                    <li key={idx} className="flex items-start">
                      <i className="ri-check-line text-green-600 mr-2 mt-1"></i>
                      <span className="text-sm text-gray-700">{f}</span>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-16 bg-gray-100">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">{t('transportWhyTitle')}</h2>
          </div>
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            {advantages.map((adv, index) => (
              <div key={index} className="text-center">
                <div className="w-16 h-16 bg-blue-600 text-white rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className={`${adv.icon} text-2xl`}></i>
                </div>
                <h3 className="text-lg font-semibold text-gray-900 mb-2">{t(adv.titleKey)}</h3>
                <p className="text-gray-600">{t(adv.descKey)}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-16 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-blue-50 rounded-lg p-8 border-l-4 border-blue-500">
            <div className="flex items-center mb-6">
              <img src="https://readdy.ai/api/search-image?query=professional%20african%20logistics%20manager%20in%20modern%20transportation%20facility%2C%20confident%20fleet%20manager%20overseeing%20successful%20delivery%20operations%20with%20advanced%20tracking%20technology&width=100&height=100&seq=amadship-owner&orientation=squarish"
                alt={t('transportTestiName')} className="w-16 h-16 rounded-full object-cover mr-4" />
              <div>
                <h3 className="text-xl font-bold text-blue-900">{t('transportTestiName')}</h3>
                <p className="text-blue-700">{t('transportTestiRole')}</p>
              </div>
            </div>
            <blockquote className="text-lg text-blue-800 italic mb-4">"{t('transportTestiQuote')}"</blockquote>
            <div className="flex items-center">
              <div className="flex text-yellow-400">{[...Array(5)].map((_, i) => <i key={i} className="ri-star-fill"></i>)}</div>
              <span className="ml-2 text-blue-700 font-medium">{t('transportSatisfied')}</span>
            </div>
          </div>
        </div>
      </section>

      <section className="bg-blue-900 text-white py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl font-bold mb-4">{t('transportCtaTitle')}</h2>
          <p className="text-xl mb-8 max-w-2xl mx-auto">{t('transportCtaDesc')}</p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a href="https://wa.me/237693385267" target="_blank" rel="noopener noreferrer"
              className="bg-green-600 hover:bg-green-700 text-white px-8 py-4 rounded-lg font-semibold transition-colors cursor-pointer whitespace-nowrap">
              <i className="ri-whatsapp-line mr-2"></i>{t('sectorFreeDemo')}
            </a>
            <a href="/solutions" className="bg-white text-blue-900 px-8 py-4 rounded-lg font-semibold hover:bg-gray-100 transition-colors cursor-pointer whitespace-nowrap">
              {t('sectorViewSolutions')}
            </a>
          </div>
        </div>
      </section>

      <Footer />
      <WhatsAppFloat />
    </div>
  );
}
